var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSupportIcon = function SvgSupportIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 3c-4.42 0-8 3.58-8 8v5c0 1.66 1.34 3 3 3h1c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1H6v-2c0-3.31 2.69-6 6-6s6 2.69 6 6v2h-2c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h1c1.66 0 3-1.34 3-3v-5c0-4.42-3.58-8-8-8M13 20h-2c-.55 0-1 .45-1 1s.45 1 1 1h2c.55 0 1-.45 1-1s-.45-1-1-1"
  })));
};
export default SvgSupportIcon;